import { CountUp } from 'countup.js';
import enterView from 'enter-view';

Alpine.data('mpModal', (options) => ({
	isLargeScreen: false,
	modalOpen: false,
	currentTab: 0, // null, 0 or 1.
	minPetitionThreshold: options.minPetitionThreshold || 0,
	endpoint: options.endpoint,
	petitionCount: null,
	petitionPercentage: 0,

	init() {
		this.lockBodyOnModalOpen();

		this.getCount();
		this.handlePetitionCountAnimation();

		this.handleEnterView();
	},

	lockBodyOnModalOpen() {
		this.$watch('modalOpen', () => {
			document.body.classList.toggle('scroll-lock', this.modalOpen);
		});
	},

	openModal(tabIndex) {
		this.currentTab = tabIndex;
		this.$dispatch('open-mp-modal', {});

		setTimeout(() => {
			this.modalOpen = true;
		}, 5);
	},
	closeModal() {
		this.modalOpen = false;
	},

	getCount() {
		this.$store.aa
			.api(this.endpoint)
			.get()
			.json((response) => {
				if (response.success === true) {
					this.petitionCount =
						response?.data?.num_signatures || response?.data?.num_sends || 0;
					this.petitionPercentage = Math.round(
						(this.petitionCount / this.getClosestTotal()) * 100
					);
				}
			})
			.catch((err) => {
				// Ad blocker
				if (
					err.message !== 'Failed to fetch' &&
					err.message !== 'Load failed'
				) {
					console.error(err);
				}
			});
	},
	getClosestTotal() {
		const milestones = [
			50, 100, 300, 1000, 5000, 20000, 50000, 100000, 500000, 1000000,
		];

		return milestones.reduce((a, b) => {
			if (a - this.petitionCount <= 0) {
				return b;
			}
			return Math.abs(b - this.petitionCount) < Math.abs(a - this.petitionCount)
				? b
				: a;
		});
	},
	handlePetitionCountAnimation() {
		const counter = new CountUp(this.$refs.petitionCount, 0, {
			duration: 2,
		});

		counter.start();

		this.$watch('petitionCount', (value) => {
			counter.update(value);
		});
	},
	handleEnterView() {
		enterView({
			selector: [this.$refs.entry],
			offset: 1,
			enter(el) {
				el.classList.add('mp-modal-banner__floating-cta--active');
			},
			exit(el) {
				el.classList.remove('mp-modal-banner__floating-cta--active');
			},
		});
	},
	addPetitionNumber() {
		this.petitionCount += 1;
	},
}));
